 
import { API_SITE_CORPO } from './api_endpoint';
import { http, httpwithtoken, httpWithNewsLetterToken  } from './http';
 

 

export const getpage = async (id:any) => {  
	
	try {
		let x=API_SITE_CORPO.PAGE+id
		
		let { data } = await http.get(x);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};


export const getPageByUrl = async (slug: string, token?: string)=>{

	try {
		let x=API_SITE_CORPO.PAGE+"/"+slug
		
		let { data } = await httpWithNewsLetterToken(token).get(x);
		return data;
	} catch (error: any) {
		if (error.response && error.response.status) {
			return error.response.status;
		  } else {
			return 500; 
		  }
		 
	}

}
 

export const getPageUrlByType = async (type: string)=>{

	try {
		let x=API_SITE_CORPO.NEWS_LETTER+"/"+type
	
		let { data } = await http.get(x);
		return data;
	} catch (error: any) {
		if (error.response && error.response.status) {
			return error.response.status;
		  } else {
			return 500; 
		  }
		 
	}

}




export const getPages = async () => {  
	
	try {
		let x=API_SITE_CORPO.PAGE
		
		let { data } = await http.get(x);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const getNewsLetter = async () => {  
	
	try {
		let x=API_SITE_CORPO.NEWS_LETTER
		
		let { data } = await http.get(x);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};
 

export const savepage = async ( objectpage:object) => {  

	try {
		let x=API_SITE_CORPO.PAGE   
		let { data } = await httpwithtoken.post(x,objectpage);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 	
	}
};
export const editpage = async ( objectpage:any) => {  
	// console.log(objectpage);

	try {
		let x=API_SITE_CORPO.PAGE +"/"+  objectpage.id
		let { data } = await httpwithtoken.put(x,objectpage);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';

		throw errorMessage; 
	}
};

export const deletePage =async (id: string) => {
	try {
		let x=API_SITE_CORPO.PAGE +"/"+ id
		let { data } = await httpwithtoken.delete(x);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 
	}
}
export const importPages =async (file: File) => {
	try {
		let x=API_SITE_CORPO.PAGE +"/import"
		let { data } = await httpwithtoken.post(x, file);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 
	}
}
